export const TREE_NAMES = {
    EXPORT_OPTIONS: 'export-options',
    PLUGINS_AND_APPS: 'plugins-and-apps',
    PLATFORM_FEATURES: 'platform-features',
    STANDARD_DATA_SETS: 'standard-data-sets',
};
